/* eslint-disable react/no-unescaped-entities */
import feature1 from "../../assets/images/all-img/about2/feature1.png";
import feature2 from "../../assets/images/all-img/about2/feature2.png";
import feature3 from "../../assets/images/all-img/about2/feature3.png";
 
export default function FeatureSection() {
	return (
		<div className="fugu--feature-section fugu--section-padding2">
			<div className="container">
				<div className="fugu--section-title2">
					<div className="row">
						<div className="col-lg-7">
							<div className="fugu--default-content content-sm">
								<h2>Our strength is to change the path of our creativity trade NFT</h2>
							</div>
						</div>
						<div className="col-lg-4 offset-lg-1">
							<div className="fugu--default-content">
								<p>
									Nexto is a universal marketplace that has been working with NFTS Art since 2002. we
									are ready to change the world with NFTs!
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-4 col-md-6">
						<div
							className="fugu--iconbox-wrap fugu--iconbox-wrap3 fugu--iconbox-wrap4 wow fadeInUpX"
							data-wow-delay="0s"
						>
							<div className="fugu--iconbox-thumb">
								<img src={feature1} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>Safe and secure</h4>
								<p>
									NFTs are safe when bought or sold on reputable exchanges, & they cannot be stolen if
									users properly secure.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div
							className="fugu--iconbox-wrap fugu--iconbox-wrap3 fugu--iconbox-wrap4 wow fadeInUpX"
							data-wow-delay=".15s"
						>
							<div className="fugu--iconbox-thumb">
								<img src={feature2} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>Complete transparency</h4>
								<p>
									Transparency in a process involves it being completely visible and open to scrutiny,
									so that it's clear.
								</p>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div
							className="fugu--iconbox-wrap fugu--iconbox-wrap3 fugu--iconbox-wrap4 wow fadeInUpX"
							data-wow-delay=".25s"
						>
							<div className="fugu--iconbox-thumb">
								<img src={feature3} alt="" />
							</div>
							<div className="fugu--iconbox-data">
								<h4>Creative team</h4>
								<p>
									Nexto has creative artists, painters, and designers working tirelessly on NFT art
									all over the world.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
